import { render } from "./sellingchart.vue?vue&type=template&id=6e7af0c2"
import script from "./sellingchart.vue?vue&type=script&lang=js"
export * from "./sellingchart.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__